import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrashPaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrashPaper"><Path d="M14 1.7981L10.6293 4.04521L3.38715 5.15939L3.91997 9.42193L2 10.3819V14.5351L3.56449 15.5781L4.0681 19.607L7.48767 21.6587L10.7535 19.7926L12.6547 22.1691L16.5071 20.885L21.274 16.7139L19.1942 13.0743L22.5189 8.64138L18 6.38191V4.46476L14 1.7981Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrashPaper;
